import { Box, Card, Stack, Typography } from '@mui/material';
import Iconify from 'src/legacy/components/iconify';
import { useLocales } from 'src/legacy/locales';
import { useSelector } from 'src/legacy/redux/store';
import { FOSTER_FAMILY_RANK_OPTIONS } from 'src/legacy/utils/consts';
import { fJoinedDate } from 'src/legacy/utils/formatTime';

export const BasicInfoCard = () => {
  const { translate } = useLocales();

  const { states } = useSelector((state) => state.common);
  const { selectedFosterFamily } = useSelector((state) => state.fosterFamily);

  return (
    <Card
      sx={{
        mb: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          mx: 3,
          my: 2.5,
        }}
      >
        <Typography variant="h4">{selectedFosterFamily?.name || ''}</Typography>

        <Stack direction="row" mt={1} spacing={8}>
          <Box sx={{ alignItems: 'center', display: 'flex', opacity: 0.72 }}>
            <Iconify icon="material-symbols:location-on-outline" />
            <Typography ml={1}>{`${
              selectedFosterFamily?.city || translate('city')
            }, ${
              states.length > 0 && selectedFosterFamily?.state
                ? states.find(
                    (state) => state.id === selectedFosterFamily.state
                  )?.name || ''
                : translate('state')
            }`}</Typography>
          </Box>

          <Box sx={{ alignItems: 'center', display: 'flex', opacity: 0.72 }}>
            <Iconify icon="material-symbols:invert-colors" />
            <Typography ml={1}>{`${FOSTER_FAMILY_RANK_OPTIONS.filter(
              (option) =>
                !!selectedFosterFamily?.rank &&
                selectedFosterFamily?.rank.includes(option.value)
            )
              .map((option) => translate(option.label))
              .join(', ')}`}</Typography>
          </Box>

          <Box sx={{ alignItems: 'center', display: 'flex', opacity: 0.72 }}>
            <Iconify icon="material-symbols:calendar-today" />
            <Typography ml={1}>{`${translate('joined')} ${
              selectedFosterFamily?.signup_date
                ? fJoinedDate(selectedFosterFamily.signup_date)
                : ''
            }`}</Typography>
          </Box>
        </Stack>
      </Box>
    </Card>
  );
};
